const getAirportICAO = (airport) => {
  return airport?.sICAO?.[0] ?? airport?.sADICAO?.[0];
};

const getContingencyLabel = (contingencyPolicy) => {
  const normalized = String(contingencyPolicy ?? '').normalize('NFKC').toUpperCase();

  if (normalized.includes('ERA')) return 'CONT 3% + ERA';
  if (normalized.replace(/\s+/g, '').includes('AIRCRAFTMINIMUMCONTFUEL')) return 'MIN CONT';
  if (normalized.includes('5%')) return 'CONT 5%';

  return 'MIN CONT';
};

const getContingencyAirportICAO = (contingencyEnrouteAlternateAirport) => {
  return contingencyEnrouteAlternateAirport?.[0]?.split('|')[1] ?? '';
};

export const isContingencyInAirportsList = (contingencyAirportICAO, airports) => {
  if (!contingencyAirportICAO || !airports) return false;
  return airports.some((airport) => getAirportICAO(airport) === contingencyAirportICAO);
};

const findContingencyAirportObject = (contingencyAirportICAO, isInAirportsList, flightData) => {
  if (!contingencyAirportICAO || isInAirportsList) return null;

  const alternateAirport = flightData?.Alt_List?.[0]?.Alternate?.find(
    (alt) => alt?.sADICAO?.[0] === contingencyAirportICAO
  );
  if (alternateAirport) return alternateAirport;

  return flightData?.Airport_List?.[0]?.AirportData?.find(
    (airport) => airport?.sICAO?.[0] === contingencyAirportICAO
  ) ?? null;
};

export const isContingencyAlsoAlternate = (contingencyAirportICAO, flightData) => {
  if (!contingencyAirportICAO || !flightData) return false;
  return flightData?.Alt_List?.[0]?.Alternate?.some(
    (alt) => alt?.sADICAO?.[0] === contingencyAirportICAO
  );
};

export const isSelectedAirportContingency = (selectedAirport, contingencyAirportICAO, contLabel) => {
  if (!selectedAirport || !contingencyAirportICAO || contLabel !== 'CONT 3% + ERA') {
    return false;
  }
  return getAirportICAO(selectedAirport) === contingencyAirportICAO;
};

export const getContingencyAirportInfo = (flightData, airports) => {
  const contingencyPolicy = flightData?.sContingencyPolicy?.[0];
  const contLabel = getContingencyLabel(contingencyPolicy);
  const contingencyAirportICAO = getContingencyAirportICAO(
    flightData?.sContingencyEnrouteAlternateAirport
  );

  if (!contingencyAirportICAO) {
    return {
      contLabel,
      contingencyAirportICAO: '',
      isInAirportsList: false,
      contingencyAirportObject: null,
      isAlsoAlternate: false,
      airportsWithContingency: airports || [],
      contingencyAirportICAOForStyling: null,
    };
  }

  const isInAirportsList = isContingencyInAirportsList(contingencyAirportICAO, airports);
  const contingencyAirportObject = findContingencyAirportObject(
    contingencyAirportICAO,
    isInAirportsList,
    flightData
  );
  const isAlsoAlternate = isContingencyAlsoAlternate(contingencyAirportICAO, flightData);

  // Check if contingency should be added to airports list
  const isEraContingency = contLabel === 'CONT 3% + ERA';
  const shouldAddContingency = isEraContingency && !isInAirportsList && contingencyAirportObject;

  return {
    contLabel,
    contingencyAirportICAO,
    isInAirportsList,
    contingencyAirportObject,
    isAlsoAlternate,
    airportsWithContingency: shouldAddContingency
      ? [...(airports || []), contingencyAirportObject]
      : airports || [],
    contingencyAirportICAOForStyling: isEraContingency && !isAlsoAlternate
      ? contingencyAirportICAO
      : null,
  };
};

